class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.facetForm = this.querySelector("form");
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.facetForm.addEventListener("submit", this.onSubmitHandler.bind(this));

    const facetOpener = this.querySelector(".facets-top__opener");
    facetOpener.addEventListener("click", this.handleFacetOpening.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  handleFacetOpening(event) {
    const toggle_button = event.currentTarget;
    if (toggle_button.getAttribute("aria-pressed") == "true") {
      toggle_button.setAttribute("aria-pressed", false);
    } else {
      toggle_button.setAttribute("aria-pressed", true);
    }

    this.facetForm.classList.toggle("in-view");
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(url, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = url;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );

    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const section_url =
        url.indexOf("?") != -1
          ? `${url}&section_id=${section.section}`
          : `${url}?section_id=${section.section}`;

      // `${baseUrl == "" ? window.location.pathname : baseUrl}/${tagFilters}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === section_url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(section_url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(url);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".sorting"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(url) {
    history.pushState({ url }, "", url);
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  createTagParams(form) {
    const tag_inputs = form.querySelectorAll(".tag-filter:checked");
    const tag_array = [];
    tag_inputs.forEach((filter) => {
      tag_array.push(filter.dataset.name);
    });

    return tag_array.join("+");
  }

  onSubmitForm(url, event) {
    FacetFiltersForm.renderPage(url, event);
    //close drawer
    const open_filters = document.querySelectorAll(
      "facet-filters-form:has(.facets-top__opener[aria-pressed='false'])",
    );

    Array.from(open_filters).forEach((el) => {
      el.setAttribute("aria-pressed", true);
    });

    this.querySelector("form").classList.remove("in-view");
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );

    const forms = [];
    var tag_filters = [];
    const isMobile =
      event.target.closest("form").id === "FacetFiltersFormMobile";

    sortFilterForms.forEach((form) => {
      if (
        form.id === "FacetSortForm" ||
        form.id === "FacetFiltersForm" ||
        form.id === "FacetSortDrawerForm"
      ) {
        forms.push(this.createSearchParams(form));

        //tag filters treated differently, change url path
        tag_filters.push(this.createTagParams(form));

        console.log(tag_filters);
      }
    });

    const url = `${this.dataset.baseUrl == "" ? window.location.pathname : this.dataset.baseUrl}/${tag_filters.join("+")}?${forms.join("&")}`;

    this.onSubmitForm(url, event);

    /*
        Need to have both tag filters and new filters
        Tag filters add onto url (/collections/all/tag1+tag2)
        New filters add url parameter (/collections/all?new_filter=value?new_filter2=value)

        Current implementation creates formData of entire form, converts to URLSearchParams and adds to forms array

        Can create new FormData and .append values depending if they are new or old

        onSubmitForm has extra string for old tags

          forms [
            [ NEW ],
            [ OLD ]
          ]
        
        DRAWBACK have to iterate over all inputs, put in correct form data obj

        OR

        treat tag filters separately by having them as inputs with no names (data-name),
        iterate over and create separate string
          More efficient,
      */
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();
    var tag_component, search_params;

    if (event.currentTarget.classList.contains("active-facets__button--tag")) {
      var { tag, current } = event.currentTarget.dataset;
      var current_array = JSON.parse(current);
      tag_component = current_array.filter((item) => item !== tag);
      search_params =
        window.location.search == ""
          ? ""
          : window.location.search.slice(
              window.location.search.indexOf("?") + 1,
            ); //use js as liquid does not provide search param, ? added within render page
    } else if (
      event.currentTarget.classList.contains("active-facets__button-remove")
    ) {
      tag_component = [];
      search_params = "";
    } else {
      //need to get current tag filters to be maintained
      const current_tag_filters = this.querySelectorAll(
        ".active-facets__button--tag",
      );
      tag_component = Array.from(current_tag_filters).map((tag_el) => {
        return tag_el.dataset.tag;
      });

      search_params =
        event.currentTarget.href.indexOf("?") == -1
          ? ""
          : event.currentTarget.href.slice(
              event.currentTarget.href.indexOf("?") + 1,
            );
    }

    const url = `${this.dataset.baseUrl == "" ? window.location.pathname : this.dataset.baseUrl}/${tag_component.join("+")}?${search_params}`;

    FacetFiltersForm.renderPage(url, event);
    //Need to pass through tagFilters and baseUrl here. How to get current filters minus this one?
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class CollectionColumns extends HTMLElement {
  constructor() {
    super();

    this.deviceIsMobile = window.matchMedia("(max-width: 749px)");

    this.addEventListener("click", this.handleColumnChange.bind(this));
  }

  handleColumnChange(event) {
    if (!event.target.closest(".facets-column")) return;

    var collectionGrid = document.querySelector("#product-grid"); //get collection each time otherwise on filter change, collection-grid is destroyed

    if (!collectionGrid) return;

    this.dataset.initialDevice = ""; //remove initial

    const target = event.target.closest(".facets-column");

    const desired_columns = target.dataset.cols;
    const current_classes = [...collectionGrid.classList];
    var responsive_class = "desktop";

    //set class based off current screen width, leaving other class

    if (this.deviceIsMobile.matches) {
      //mobile browser
      responsive_class = "tablet-down";
      let initial_mobile_el = this.querySelector(".active--init-mb");
      if (initial_mobile_el)
        initial_mobile_el.classList.remove("active--init-mb");
    } else {
      //desktop
      let initial_desktop_el = this.querySelector(".active--init-dt");
      if (initial_desktop_el)
        initial_desktop_el.classList.remove("active--init-dt");
    }

    if (target.classList.contains("active")) return;
    this.setActive(target);

    var column_regex = new RegExp(`^grid--.*-${responsive_class}$`);

    for (let i = 0; i < current_classes.length; i++) {
      const current_class = current_classes[i];
      if (column_regex.test(current_class)) {
        collectionGrid.classList.remove(current_class);
        collectionGrid.classList.add(
          `grid--${desired_columns}-col-${responsive_class}`,
        );
        break;
      }
    }

    //set promo grid to end at each line
    collectionGrid.style.setProperty("--items-per-row", desired_columns);

    //show hidden promos that should be visible
    var all_product_items = collectionGrid.querySelectorAll(
      ".grid__item:not(.promo-tile)",
    );
    var all_promo_items = collectionGrid.querySelectorAll(".promo-tile");

    var total_rows = all_product_items.length / parseInt(desired_columns);
    var show_limit = 12;
    //HARD CODED BITCH
    collectionGrid.style.setProperty("--tile-row", 1);

    switch (parseInt(desired_columns)) {
      case 4: {
        show_limit = 4;
        break;
      }
      case 3: {
        show_limit = 6;
        break;
      }
      case 2: {
        show_limit = 8;
        break;
      }
      case 1: {
        show_limit = 8;
        collectionGrid.style.setProperty("--tile-row", 3);
        break;
      }
    }

    Array.from(all_promo_items).forEach((promo_item) => {
      var tile_number = promo_item.dataset.count;
      if (parseInt(tile_number) <= show_limit) {
        promo_item.dataset.visible = "true";
      } else {
        promo_item.dataset.visible = "false";
      }
    });
  }

  setActive(item) {
    const current_active = this.querySelector(".active");
    if (current_active) {
      current_active.classList.remove("active");
    }
    item.classList.add("active");
  }
}

customElements.define("collection-columns", CollectionColumns);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
